var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"color":"primary"},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []

export { render, staticRenderFns }